"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiFileUpload = exports.useMultiFileUpload = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
require("./MultiFileUpload.css");
var Button_1 = require("../../components/Button");
var openFileDialog_1 = require("../../utils/openFileDialog");
var Stack_1 = require("../../components/Stack");
var Row_1 = require("../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var MDIcon_1 = require("../../components/MDIcon");
var FileDropZone_1 = require("../../components/FileDropZone");
var Grid_1 = require("../../components/Grid");
var intl_1 = require("./intl");
var useMultiFileUpload = function () {
  var _a = __read((0, react_1.useState)([]), 2),
    files = _a[0],
    setFiles = _a[1];
  var addFiles = function (newFiles, maxFileCount, maxFileSize, onFileTooBig) {
    if (maxFileCount === void 0) {
      maxFileCount = Infinity;
    }
    if (maxFileSize === void 0) {
      maxFileSize = Infinity;
    }
    if (onFileTooBig === void 0) {
      onFileTooBig = function (f) {};
    }
    var filteredFiles = newFiles.filter(function (f) {
      var tooBig = f.size > maxFileSize;
      if (tooBig) onFileTooBig(f);
      return !tooBig;
    });
    setFiles(function (v) {
      var pickProps = R.pick(["name", "type", "size", "lastModified"]);
      var newData = R.uniqBy(pickProps, __spreadArray(__spreadArray([], __read(v), false), __read(filteredFiles), false));
      return newData.slice(0, maxFileCount);
    });
  };
  var removeFile = function (idx) {
    setFiles(R.remove(idx, 1));
  };
  var clearFiles = function () {
    return setFiles([]);
  };
  var totalFileSize = [0].concat(files.map(function (f) {
    return f.size;
  })).reduce(R.add);
  var config = {
    files: files,
    addFiles: addFiles,
    removeFile: removeFile,
    clearFiles: clearFiles,
    totalFileSize: totalFileSize
  };
  return config;
};
exports.useMultiFileUpload = useMultiFileUpload;
(0, MDIcon_1.preloadIcons)("attachment-plus", "attachment-off");
var columnsMap = {
  "hide": "1fr",
  "bottom": "1fr",
  "right": "1fr auto",
  "left": "auto 1fr"
};
var MultiFileUpload = function (_a) {
  var _b = _a.files,
    files = _b === void 0 ? [] : _b,
    addFiles = _a.addFiles,
    removeFile = _a.removeFile,
    onRejectFile = _a.onRejectFile,
    _c = _a.onFileTooBig,
    onFileTooBig = _c === void 0 ? R.N : _c,
    _d = _a.maxFiles,
    maxFiles = _d === void 0 ? Infinity : _d,
    _e = _a.maxFileSize,
    maxFileSize = _e === void 0 ? Infinity : _e,
    intl = _a.intl,
    _f = _a.disabled,
    disabled = _f === void 0 ? false : _f,
    className = _a.className,
    _g = _a.accept,
    accept = _g === void 0 ? "*" : _g,
    info = _a.info,
    _h = _a.dragDrop,
    dragDrop = _h === void 0 ? false : _h,
    totalFileSize = _a.totalFileSize,
    clearFiles = _a.clearFiles,
    _j = _a.error,
    error = _j === void 0 ? false : _j,
    _k = _a.buttonPlacement,
    buttonPlacement = _k === void 0 ? "bottom" : _k,
    restProps = __rest(_a, ["files", "addFiles", "removeFile", "onRejectFile", "onFileTooBig", "maxFiles", "maxFileSize", "intl", "disabled", "className", "accept", "info", "dragDrop", "totalFileSize", "clearFiles", "error", "buttonPlacement"]);
  var _l = (0, react_1.useMemo)(function () {
      return (0, intl_1.createMultiFileUploadIntl)(intl);
    }, [intl]),
    placeholder = _l.placeholder,
    browse = _l.browse,
    filesAtMax = _l.filesAtMax;
  var maxFilesMet = files.length >= maxFiles;
  var chooseFiles = function () {
    return (0, openFileDialog_1.openFileDialog)({
      accept: accept,
      multiple: maxFiles > 1,
      callback: function (e) {
        if (e.currentTarget.files !== null) {
          var newFiles = Array.from(e.currentTarget.files);
          addFiles(newFiles, maxFiles, maxFileSize, onFileTooBig);
        }
      }
    });
  };
  var cn = (0, classnames_1.default)("vsx-multi-file-upload", className);
  var displayTooltip = maxFilesMet ? filesAtMax : browse;
  var onDropFiles = function (files) {
    addFiles(files, maxFiles, maxFileSize, onFileTooBig);
  };
  var uploadButton = (0, jsx_runtime_1.jsx)(Button_1.IconButton, {
    className: "vsx-multi-file-upload-button",
    tooltip: displayTooltip,
    icon: maxFilesMet || disabled ? "attachment-off" : "attachment-plus",
    disabled: maxFilesMet || disabled,
    tooltipProps: {
      disabled: disabled,
      placement: "right"
    },
    rotation: "270deg",
    onClick: chooseFiles
  });
  var horizontalButton = buttonPlacement !== "bottom" && buttonPlacement !== "hide";
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    className: cn,
    gap: "small"
  }, restProps, {
    children: [(0, jsx_runtime_1.jsxs)(Grid_1.Grid, __assign({
      style: {
        maxWidth: "100%"
      },
      align: "start",
      gap: "small",
      columns: columnsMap[buttonPlacement]
    }, {
      children: [buttonPlacement === "left" ? uploadButton : null, (0, jsx_runtime_1.jsx)(FileDropZone_1.FileDropZone, __assign({
        onDropFiles: onDropFiles,
        onRejectFile: onRejectFile,
        disabled: !dragDrop || disabled,
        accept: accept
      }, {
        children: (0, jsx_runtime_1.jsx)(MultiFileUploadList, {
          error: error,
          placeholder: placeholder,
          files: files,
          removeFile: removeFile,
          disabled: disabled
        })
      })), buttonPlacement === "right" ? uploadButton : null]
    })), (0, jsx_runtime_1.jsx)(MultiFileUploadInfoRow, {
      renderButton: buttonPlacement === "bottom",
      uploadButton: uploadButton,
      info: info
    })]
  }));
};
exports.MultiFileUpload = MultiFileUpload;
var MultiFileUploadInfoRow = function (_a) {
  var renderButton = _a.renderButton,
    uploadButton = _a.uploadButton,
    info = _a.info;
  var shouldRender = renderButton || !!info;
  return shouldRender ? (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    align: "start"
  }, {
    children: [renderButton ? uploadButton : (0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-multi-file-upload-info"
    }, {
      children: info
    }))]
  })) : null;
};
var MultiFileUploadList = function (_a) {
  var files = _a.files,
    placeholder = _a.placeholder,
    disabled = _a.disabled,
    error = _a.error,
    removeFile = _a.removeFile;
  return (0, jsx_runtime_1.jsx)(Grid_1.Grid, __assign({
    columns: "1fr auto",
    spacing: "small",
    align: "center",
    paddingLeft: "medium",
    className: (0, classnames_1.default)("vsx-multi-file-upload-list", error && "vsx-multi-file-upload-list-error")
  }, {
    children: files.length === 0 ? (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-multi-file-upload-placeholder"
    }, {
      children: placeholder
    })) : files.map(function (file, idx) {
      return (0, jsx_runtime_1.jsxs)(react_1.Fragment, {
        children: [(0, jsx_runtime_1.jsx)("span", __assign({
          className: "vsx-multi-file-upload-filename"
        }, {
          children: file.name
        })), (0, jsx_runtime_1.jsx)(Button_1.IconButton, {
          className: "vsx-multi-file-upload-remove-button",
          size: 20,
          disabled: disabled,
          icon: "close",
          freeSize: true,
          onClick: function () {
            return removeFile(idx);
          }
        })]
      }, idx);
    })
  }));
};